<template>
  <div class="main-cell">
    <div class="cell-before">
      <v-icon class="item hover q-green-add-color" @click="addNew">add</v-icon>
      <v-icon
        class="item hover q-orange-disable-color"
        style="border-top: solid thin #ddd"
        @click="disableEmployee"
      >
        transfer_within_a_station</v-icon
      >
    </div>
    <!-- <div v-else :class="{ 'cell-before-closed': isClosed }" class="cell-before">
    </div> -->
   
    <div
      class="cell"
      @mouseover="mouseover"
      @mouseout="mouseout"
      :class="{ 'cell-hover': isHover, 'cell-na': notAvailable }"
    >
    <div style="position: relative">
                  <div v-show="isDisabling" class="overlay">
                    <v-progress-circular indeterminate> </v-progress-circular>
                  </div>
              <div>
      <span class="cell-hour">{{ hour }}:{{ minutesToShow }}</span>
      <div style="height: 20px; width: 100%">
        <cal-card
          ref="myCard1"
          :fullDate="fullDate"
          :emp="emp"
          @move="move"
          @details="details"
          @multiDetails="multiDetails"
          :empId="empId"
          :hour="hour"
          :day="day"
          :min="Number.parseInt(minutes) < 30 ? '00' : '30'"
        ></cal-card>
        <div
          :class="{
            'cell-closed':
              !showCard(Number.parseInt(minutes) < 30 ? '00' : '30') ||
              isClosed,
          }"
        ></div>
      </div>
      <div style="height: 20px; width: 100%">
        <cal-card
          ref="myCard2"
          :fullDate="fullDate"
          :emp="emp"
          @move="move"
          @details="details"
          @multiDetails="multiDetails"
          :empId="empId"
          :hour="hour"
          :day="day"
          :min="Number.parseInt(minutes) < 30 ? '05' : '35'"
        ></cal-card>
        <div
          :class="{
            'cell-closed':
              !showCard(Number.parseInt(minutes) < 30 ? '05' : '35') ||
              isClosed,
          }"
        ></div>
      </div>
      <div style="height: 20px; width: 100%">
        <cal-card
          ref="myCard3"
          :fullDate="fullDate"
          :emp="emp"
          @move="move"
          @details="details"
          @multiDetails="multiDetails"
          :empId="empId"
          :hour="hour"
          :day="day"
          :min="Number.parseInt(minutes) < 30 ? '10' : '40'"
        ></cal-card>
        <div
          :class="{
            'cell-closed':
              !showCard(Number.parseInt(minutes) < 30 ? '10' : '40') ||
              isClosed,
          }"
        ></div>
      </div>
      <div style="height: 20px; width: 100%">
        <cal-card
          ref="myCard4"
          :fullDate="fullDate"
          :emp="emp"
          @move="move"
          @details="details"
          @multiDetails="multiDetails"
          :empId="empId"
          :hour="hour"
          :day="day"
          :min="Number.parseInt(minutes) < 30 ? '15' : '45'"
        ></cal-card>
        <div
          :class="{
            'cell-closed':
              !showCard(Number.parseInt(minutes) < 30 ? '15' : '45') ||
              isClosed,
          }"
        ></div>
      </div>
      <div style="height: 20px; width: 100%">
        <cal-card
          ref="myCard5"
          :fullDate="fullDate"
          :emp="emp"
          @move="move"
          @details="details"
          @multiDetails="multiDetails"
          :empId="empId"
          :hour="hour"
          :day="day"
          :min="Number.parseInt(minutes) < 30 ? '20' : '50'"
        ></cal-card>
        <div
          :class="{
            'cell-closed':
              !showCard(Number.parseInt(minutes) < 30 ? '20' : '50') ||
              isClosed,
          }"
        ></div>
      </div>
      <div style="height: 20px; width: 100%">
        <cal-card
          ref="myCard6"
          :fullDate="fullDate"
          :emp="emp"
          @move="move"
          @details="details"
          @multiDetails="multiDetails"
          :empId="empId"
          :hour="hour"
          :day="day"
          :min="Number.parseInt(minutes) < 30 ? '25' : '55'"
        ></cal-card>
        <div
          :class="{
            'cell-closed':
              !showCard(Number.parseInt(minutes) < 30 ? '25' : '55') ||
              isClosed,
          }"
        ></div>
        </div>
      </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import ajax from "../../../ajax.js";
import Utils from "../../../utils.js";
import CalCard from "./CalCard";
import Moment from "moment";
var ut = new Utils();
export default {
  name: "CalCell",
  components: {
    CalCard,
  },
  props: {
    na: {
      type: Array,
      default: [],
    },
    ferie: {
      type: Boolean,
      default: false,
    },
    shop: {
      type: Number,
      default: 0,
    },
    dow: {
      type: Number,
      default: 0,
    },
    fullDate: {
      type: String,
      default: "",
    },
    openTM: {
      type: String,
      default: "00:00",
    },
    closeTM: {
      type: String,
      default: "00:00",
    },
    openAF: {
      type: String,
      default: "00:00",
    },
    closeAF: {
      type: String,
      default: "00:00",
    },
    day: {
      type: String,
      default: "01",
    },
    selectedCard: {
      type: Object,
      default: null,
    },
    emp: {
      type: Number,
    },
    hour: {
      type: String,
      default: "00",
    },
    empId: {
      type: Number,
      default: 0,
    },
    minutes: {
      type: String,
      default: "00",
    },
    isClosed: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    na: function () {
      this.isNotAvailable();
      // setTimeout(() => {
      //   // Messo qui dentro perchè in tempo reale non aggiornava.

      // }, 500);
    },
  },
  mounted: function () {
    this.getCards();
    this.isNotAvailable();
  },
  computed: {
    isHour: function () {
      if (this.minutes === "00") return true;
      return false;
    },
    minutesToShow: function () {
      return Number.parseInt(this.minutes) < 30 ? "00" : "30";
    },
    hasReservation: function () {
      var temp = 0;
      if (this.$refs.myCard1 !== undefined)
        temp += this.$refs.myCard1.getResNumber();
      if (this.$refs.myCard2 !== undefined)
        temp += this.$refs.myCard2.getResNumber();
      if (this.$refs.myCard3 !== undefined)
        temp += this.$refs.myCard3.getResNumber();
      if (this.$refs.myCard4 !== undefined)
        temp += this.$refs.myCard4.getResNumber();
      if (this.$refs.myCard5 !== undefined)
        temp += this.$refs.myCard5.getResNumber();
      if (this.$refs.myCard6 !== undefined)
        temp += this.$refs.myCard6.getResNumber();
      return temp > 0;
    },
  },
  data: () => {
    return {
      isHover: false,
      notAvailable: false,
      isDisabling: false,
    };
  },
  methods: {
    isNotAvailable: function () {
      if (this.na.length == 0) this.notAvailable = false;
      for (let index = 0; index < this.na.length; index++) {
        const element = this.na[index];
        if (element.start !== null && element.end !== null) {
          const naTime = Moment(this.fullDate)
            .add(this.hour, "hour")
            .add(this.minutes, "m");

          const cellTimeStart = Moment(element.date)
            .add(element.start.split(":")[0], "h")
            .add(element.start.split(":")[1], "m");
          const cellTimeEnd = Moment(element.date)
            .add(element.end.split(":")[0], "h")
            .add(element.end.split(":")[1], "m");

          if (
            naTime.isBetween(cellTimeStart, cellTimeEnd, null, "[)")
            /* element.start.split(':')[0] === this.hour &&
          element.start.split(':')[1] === this.minutes &&
          element.date.split('T')[0] === this.fullDate.split('T')[0] */
          ) {
            // console.log(element.date);
            // console.log(this.fullDate)
            // console.log(this.hour);
            // console.log(this.minutes)
            // console.log(naTime)
            // console.log(cellTimeStart)
            // console.log(cellTimeEnd)
            this.notAvailable = true;
            break;
          } else {
            this.notAvailable = false;
          }
        } else {
          const naTime = Moment(this.fullDate);
          const cellTimeStart = Moment(element.date);
          if (naTime.isSame(cellTimeStart, "day")) this.notAvailable = true;
        }
      }
    },
    disableEmployee: function () {
      let self = this;
      
      if (this.ferie) {
        this.$emit(
          "siteAlert",
          "Collaboratore in ferie. Disabilita la ferie prima di poter usare questa funzione."
        );
        return;
      }
      if (this.isDisabling) {
        this.$emit("siteAlert", "Operazione già in corso, attendi che finisca");
        return;
      }
      this.isDisabling = true;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.shop +
            "/employee/" +
            self.empId +
            "/date/" +
            self.fullDate.split("T")[0] +
            "T" +
            self.hour +
            ":" +
            (Number.parseInt(self.minutes) < 30 ? "00" : "30") +
            ":00",
          {},
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          if (response.data.data === "added") {
            self.notAvailable = true;
          } else {
            self.notAvailable = false;
          }
          setTimeout(() => {
            self.isDisabling = false;
          }, 200);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
          setTimeout(() => {
            self.isDisabling = false;
          }, 200);
        });
    },
    addNew: function () {
      this.$emit("addNew", {
        isFirst: Number.parseInt(this.minutes) < 30,
        hour: this.hour,
        emp: this.empId,
        day: this.day,
        date: this.fullDate,
        dow: this.dow,
      });
    },
    move: function (card) {
      this.$emit("move", card);
    },
    getCards: function () {
      var temp = [];
      if (this.$refs.myCard1 !== undefined) temp.push(this.$refs.myCard1);
      if (this.$refs.myCard2 !== undefined) temp.push(this.$refs.myCard2);
      if (this.$refs.myCard3 !== undefined) temp.push(this.$refs.myCard3);
      if (this.$refs.myCard4 !== undefined) temp.push(this.$refs.myCard4);
      if (this.$refs.myCard5 !== undefined) temp.push(this.$refs.myCard5);
      if (this.$refs.myCard6 !== undefined) temp.push(this.$refs.myCard6);
      this.$emit("appendCard", temp);
    },
    showCard: function (cardMin) {
      if (
        Number.parseInt(this.openTM.split(":")[0]) ===
        Number.parseInt(this.hour)
      ) {
        if (
          Number.parseInt(this.openTM.split(":")[1]) > Number.parseInt(cardMin)
        ) {
          return false;
        }
      } else {
        if (
          Number.parseInt(this.openAF.split(":")[0]) ===
          Number.parseInt(this.hour)
        ) {
          if (
            Number.parseInt(this.openAF.split(":")[1]) >
            Number.parseInt(cardMin)
          ) {
            return false;
          }
        } else {
          if (
            Number.parseInt(this.closeTM.split(":")[0]) ===
            Number.parseInt(this.hour)
          ) {
            if (
              Number.parseInt(this.closeTM.split(":")[1]) <=
              Number.parseInt(cardMin)
            ) {
              return false;
            }
          } else {
            if (
              Number.parseInt(this.closeAF.split(":")[0]) ===
              Number.parseInt(this.hour)
            ) {
              if (
                Number.parseInt(this.closeAF.split(":")[1]) <=
                Number.parseInt(cardMin)
              ) {
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    mouseover: function () {
      if (!this.hasReservation) this.isHover = true;
    },
    mouseout: function () {
      this.isHover = false;
    },
    details: function (card) {
      this.$emit("details", card);
    },
    multiDetails: function (val) {
      this.$emit("multiDetails", val);
    },
  },
};
</script>

<style scoped>
.main-cell {
  display: flex;
}

.cell-before {
  display: flex;
  flex-direction: column;
  height: 120px;
  width: 40px;
  background: var(--background-color);
  border-bottom: solid thin #ddd;
  border-left: solid thin #ddd;
  border-top: solid thin #ddd;
}

.cell-before .item {
  flex-grow: 1;
  cursor: pointer;
}

.cell {
  position: relative;
  width: 200px;
  height: 120px;
  border: solid thin #ddd;
  border-top: none;
  text-align: center;
  overflow: visible;
  background: var(--background-color);
}

.cell-without-before {
  width: 240px;
}

.cell-hover {
  background: #e6d6b8;
  cursor: pointer;
  cursor: pointer;
  font-weight: bold;
}

.cell-hour {
  position: absolute;
  left: 0;
  right: 0;
  color: var(--text-color);
}

.cell-min {
  text-align: left;
  font-size: 10px;
  color: #999;
  padding-left: 3px;
  padding-top: 3px;
}

.cell-na {
  /* height: 100%; */
  background-color: var(--background-color);
  background: var(--gradien-not-available);
}

.cell-na:hover {
  cursor: not-allowed;
}

/* .cell-before-closed {
  background-color: var(--background-color);
  background: var(--gradien-closed);
  border: transparent;
} */

.cell-closed {
  width: 100%;
  height: 100%;
  background-color: var(--background-color);
  background: var(--gradien-closed);
  border: transparent;
}

.cell-closed:hover {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/CalCell.vue